<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Multi-Item Carousel</strong></h4>
      <a href="https://mdbootstrap.com/vue/advanced/carousel/#multi-item/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-4" />
    <container class="mt-5">
      <carousel :interval="8000" showControls showIndicators multi slide>
        <carousel-item>
          <row>
            <column md="4">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(34).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(18).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(35).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
          </row>
        </carousel-item>
        <carousel-item>
          <row>
            <column md="4">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(60).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(47).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(48).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
          </row>
        </carousel-item>
        <carousel-item>
          <row>
            <column md="4">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(53).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(45).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
            <column md="4" class="clearfix d-none d-md-block">
              <card class="mb-2">
                <card-img src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20(51).jpg" alt="Card image cap" waves></card-img>
                <card-body>
                  <card-title>Card title</card-title>
                  <card-text>Some quick example text to build on the card title and make up the bulk of the card's content.</card-text>
                  <btn color="primary">Button</btn>
                </card-body>
              </card>
            </column>
          </row>
        </carousel-item>
      </carousel>
    </container>
  </container>
</template>

<script>
import { Carousel, CarouselItem, CarouselCaption, Container, Row, Column, Card, CardImg, CardBody, CardTitle, CardText, Btn, Fa } from 'mdbvue';

export default {
  name: 'CarouselPage',
  components: {
    Carousel,
    CarouselItem,
    CarouselCaption,
    Container,
    Row,
    Column,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardText,
    Btn,
    Fa
  }
};
</script>

<style scoped>
</style>
